module.exports = __webpack_public_path__ + "github-3-1f530a1afa7c84013a27be010ac8e4d1.webp";